/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-list[_ngcontent-%COMP%]{margin-top:10px}.mat-list-item-content[_ngcontent-%COMP%]{display:flex}.mat-form-field[_ngcontent-%COMP%]{flex:1;margin:10px}.add-button[_ngcontent-%COMP%]{margin-left:20px}"];
export { styles as styles };
